<template>
	<div>
	  <div class="about">
		<div :class="'header-image default-header-'+rand">
			<SubTopNav title="Error" />	
		</div>
	    
    	<div class="page-content">


    		
    		<h3><strong>Sorry! </strong>the page you're looking for can not be found.</h3>
    		<div style="min-height:200px">Go to the <router-link to="/">Home Page &raquo;</router-link></div>
    		<!-- <div>&nbsp;</div> -->

		</div>
		
	    
	  </div>
  </div>
</template>
<script>
// @ is an alias to /src
	import SubTopNav from "@/components/SubTopNav.vue";


	export default {
	  name: "about",
	  components: {
	    SubTopNav
	  },
	  data: function(){
	  	return {
	
	  		rand:1
	
	  	}
	  },

	  mounted(){

	  	
	  	this.rand = Math.floor(Math.random() * 8) + 1  
	  },
	  

	};
</script>
<style scoped>
	
	

	.page-grid{
		display:grid;
		grid-template-columns: 1fr 1fr;
		grid-gap:25px;
	}

	.about{
		overflow-x:hidden;
	}

	.page-grid .item{
		xbackground:#CCC;
		xpadding:10px;
	}

	.page-grid .item:nth-child(1){
		xborder:1px solid red;
		grid-column: 1 / 3;
	}

	.page-grid .item:nth-child(1) .body-row{
		xdisplay:grid;
		xgrid-template-columns: 1fr 1fr;
		xborder:10px solid #e1e1e1;
		xpadding:25px;
		grid-gap:25px;
		margin-top:25px;
		margin-bottom:25px;
		xborder-radius:0px 0px 85px 0px;
	}

	/*.page-grid .item:nth-child(1) .body-row div:nth-child(1){
		padding:25px;
	}

	.page-grid .item:nth-child(1) .body-row div:nth-child(2) h3{
		margin-top:55px;
	}

	.page-grid .item:nth-child(1) .body-row div:nth-child(2){
		xpadding:25px;
	}

	.page-grid img{
		width:100%;
	}*/

	.page-grid .item:nth-child(2){
		border-top:5px solid #CC0000;
		padding-top:20px;
		margin-top:20px;
	}

	.page-grid .item:nth-child(3){
		border-top:5px solid #663300;
		padding-top:20px;
		margin-top:20px;
	}

	.page-grid .item:nth-child(4){
		xborder-top:5px solid #339900;
		color:#FFF;
		background:#339900;
		font-size:120%;
		padding:20px 320px;
		margin-left:-300px;
		margin-right:-300px;
		margin-top:20px;
		grid-column:1 / 3;
	}

	

	.page-content{
		text-align:left;
		xmargin-bottom:30px;
	}

	.image-break{
		height:300px;
		xbackground:#CCC;
		margin-top:35px;
		margin-bottom:35px;
	}

	.image-box{
		height:300px;
		top:0;
		left:0;
		filter: grayscale(100%);
		xopacity:0.3;
	}

	.image-text{
		margin-top:-300px;
		z-index:50;
		position:relative;
	}

	.image-text a{
		color:#FFF;
	}

	.image-text .container div{
		background:rgba(255,102,0,0.8);
		color:#FFF;
		padding:105px 50px 50px 50px;
		float:left;
		width:50%;
		height:300px
	}

	.page-content .content-body:nth-child(2n) .image-text .container div{
		float:right;
		background:rgba(102,153,51,0.8);
		
	}

	.item-group{
		display:grid;
		grid-template-columns:1fr 1fr 1fr 1fr;
		grid-gap:25px;

	}

	.group-item{
		xpadding:25px;
		box-shadow:3px 3px 5px #CCC;
		background-size:25px;
		cursor:pointer;
		border-radius:0 0 25px 0;
		margin-bottom:40px;
	}

	.group-item .name{
		padding:25px;
	}

	.page-subheader{
		margin-top:40px;
	}

	

	.group-item img{
		width:100%;
	}

	.group-item .img{
		height:250px;
		overflow:hidden;
	}

	.body-row{
		xpadding:25px;
	}

	.item-group-2{
		display:grid;
		grid-template-columns: 1fr 2fr;
	}

	.item-view{
		position:fixed;
		right:0;
		top:0;
		height:100vh;
		z-index:100;
		width:800px;
		max-width:100%;
		text-align:left;
		color:#FFF;
		padding:50px;
		xoverflow-y:scroll;
		/*right:0;
		top:0;
		width:800px;
		max-width:100%;*/
		background:rgba(0,115,60,0.9);
	}


	.item-view img{
		width:300px;
		float:left;
		margin:0 40px 20px 0;
	}

	.item-view div{
		margin-bottom:30px;
	}


	.item-close-icon{
		float:right;
		cursor:pointer;
		margin-top:-40px;
		margin-right:-40px;
		margin-left:15px;
	}
</style>